<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">person</v-icon>
			<v-toolbar-title>Autorzy opinii placówek</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<div style="display: flex; flex-direction: row; justify-content: space-between">
						<v-subheader>
							<strong>{{getEvaluationsListLabel}}</strong>
						</v-subheader>
						<v-btn flat icon class="mr-5" @click="handleListExpansion">
							<v-icon>{{getEvaluationAuthorsListIcon}}</v-icon>
						</v-btn>
					</div>
				</v-flex>
				<v-flex xs6>
					<i v-if="!showEvaluationsList">Lista ukryta</i>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs9>
					<v-expand-transition v-if="showEvaluationsList">
						<v-list>
							<v-list-group v-for="evaluationAuthor in evaluationAuthors" :value="true"
								:key="evaluationAuthor.id" prepend-icon="person" no-action>
								<v-list-tile slot="activator">
									<v-list-tile-content>
										<v-list-tile-title v-html="getFullName(evaluationAuthor)"
											style="font-size: 14px"></v-list-tile-title>
										<v-list-tile-sub-title
											v-html="evaluationAuthor.email"></v-list-tile-sub-title>
									</v-list-tile-content>
								</v-list-tile>
								<v-list-tile v-for="agency in evaluationAuthor.agencyEvaluationCodes"
									:key="agency.agencyId">
									<v-list-tile-content class="ml-4 mt-1">
										<v-list-tile-sub-title>{{ agency.agencyName }}</v-list-tile-sub-title>
										<v-list-tile-action-text
											v-html="'Opinie w ofertach nr: ' + getOfferCodes(agency.offerCodes)"></v-list-tile-action-text>
									</v-list-tile-content>
									<v-list-tile-action>
										<v-icon>{{ agency.name }}</v-icon>
									</v-list-tile-action>
								</v-list-tile>
							</v-list-group>
						</v-list>
					</v-expand-transition>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {AgencyEvaluation} from "@/api/generated/AgencyEvaluation";

	export default {
		name: "ContestSummaryAgencyEvaluationAuthors",
		data() {
			return {
				evaluationAuthors: [],
				showEvaluationsList: false,
				dataLoaded: true
			};
		},
		created() {
			this.getEvaluationAuthorsList();
		},
		computed: {
			getEvaluationsListLabel() {
				return this.showEvaluationsList ? 'Ukryj listę' : 'Wyświetl listę';
			},

			getEvaluationAuthorsListIcon() {
				return this.showEvaluationsList ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
			}
		},
		methods: {
			getEvaluationAuthorsList() {
				AgencyEvaluation.getContestEvaluationAuthors(this, this.$route.params.id, onSuccess => {
						this.evaluationAuthors = onSuccess;
					},
					onError => {
						this.$messagesBus.emit("error", "nie udało się wczytać listy autorów opinii placówek");
					});
			},
			handleListExpansion() {
				this.showEvaluationsList = !this.showEvaluationsList;
			},
			getFullName(item) {
				return item.name + ' ' + item.surname;
			},
			getOfferCodes(offerCodes) {
				if (offerCodes.length == 0) return "";
				let allCodes = offerCodes[0];
				for (let i = 1; i < offerCodes.length; i++) {
					allCodes = allCodes + ', ' + offerCodes[i];
				}
				return allCodes;
			}
		}
	};
</script>

<style scoped>

</style>
